import script from "./SetModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetModal.vue?vue&type=script&setup=true&lang=ts"

import "./SetModal.vue?vue&type=style&index=0&id=c53ffd62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c53ffd62"]])

export default __exports__